import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-997a450c")

_pushScopeId("data-v-997a450c")
const _hoisted_1 = { class: "card-text-main" }
const _hoisted_2 = { class: "main" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ['card-text', _ctx.enable?'enable':'']
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.text), 1),
      _createVNode("p", null, _toDisplayString(_ctx.title), 1)
    ])
  ], 2))
})